<template>
  <div>
    <div>
      <div class="row mr-0 ml-0" style="margin-bottom: 20px">
        <div class="newsFeedTitle">News</div>
      </div>
      <div
        class="newsFeedCardBodyLayout style-3"
        v-if="newsFeedList.length > 0"
      >
        <div
          class="row mr-0"
          v-for="(item, index) in newsFeedList"
          :key="index"
          style="
            border-bottom: 1px solid #f0f0f0;
            margin-top: 10px;
            margin-bottom: 10px;
          "
        >
          <!-- @mouseover="showIcons(index)"
          @mouseleave="hideIcons(index)"-->
          <!-- <div class="col-12 notesCardBodyNameAndDateColParent">
            <div class="d-flex">
              <div class="flex-grow-1">
                <span class="notesCardBodyName">{{item.source}},</span>
                <span
                  class="notesCardBodyDate"
                >on {{new Date(item.time).getDate()}} {{monthArray[new Date(item.time).getMonth()]}} {{new Date(item.time).getFullYear()}}</span>
              </div>
              <div class>
                <div
                  class="d-flex"
                  style="opacity:0.24;font-size:12px;line-height:24px;cursor:pointer;visibility:hidden"
                  :id="`newsfeedIcons${index}`"
                >
                  <div style="padding-right:12px" class>
                    <i class="fas fa-thumbs-up"></i>
                  </div>
                  <div style="padding-top:2px" class>
                    <i class="fas fa-thumbs-down"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <!-- <div class="col-12">
            <div class="notesCardBodyDescription" style="padding-bottom:8px">
              {{item.title }}
              <span
                @click="readMoreMethod(item)"
                style="text-decoration:underline;cursor:pointer"
              >Read More</span>
            </div>
            <div class="newsFeedBottomLine"></div>
          </div>-->
          <div
            class="d-flex notesCardBodyNameAndDateColParent"
            style="padding-left: 15px"
          >
            <div class="notesCardBodyDate" style="margin-right: 15px">
              {{ getParsedDate(item) }}
              {{ monthArray[new Date(item.time).getMonth()] }}
              {{ new Date(item.time).getFullYear() }}
            </div>
            <div
              class="newsTitle"
              v-if="context == 'lpDashboard'"
              @click="goToPortfolio(item.about_company)"
              
            >
              <div class="notesCardBodyName" style="color: #5445f3">
                {{ item.about_company }} - 
              </div>
            </div>
            <div>
              <!-- <div class="notesCardBodyName" v-if="context=='Dashboard'">: {{item.source }} -</div> -->
              <!-- <div class="notesCardBodyName" v-else>{{item.source }} -</div> -->
              <div class="notesCardBodyName">{{ item.source }} -</div>
            </div>
            <!-- v-if="item.feed_type!='full'" -->
            <div
              class="notesCardBodyNameAndDateColParent newsTitle"
              @click="openNewsPage(item)"
            >
              <div class="notesCardBodyDescription" style="color: #5445f3">
                {{ item.title }}
              </div>
            </div>
            <!-- <div
              class="notesCardBodyNameAndDateColParent"
              @click="readMoreMethod(item)"
              v-if="item.feed_type =='full'"
            >
              <div class="d-flex notesCardBodyDescription">
                <div class="readMoreEllipses">{{item.title}}</div>
                <div class="newsTitle">
                  <div style="color:#5445F3;margin-left:5px;margin-right:5px">Read More</div>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
      <div
        v-else
        style="justify-content: center; display: flex; color: #707070"
      >
        No records to view
      </div>
    </div>
    <el-dialog
      title="Fiifi News"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="
        newsModal = false;
        newsItem = {};
      "
      width="100%"
      class="newModalCls"
      :visible.sync="newsModal"
    >
      <div slot="title" style="margin-right: 30px; color: #ffff">
        <div class="d-flex" style="justify-content: space-between">
          <div class="fiifiNewsTitle">Fiifi News</div>
          <div v-if="newsItem && newsItem.link && showIFrame">
            <!-- <span
              style="cursor:pointer;text-decoration:underline;font-family:custom-helvetica"
              v-b-tooltip
              title="Click here to open this story in a new window"
            >Can't View?</span>-->
            <!-- <i
              class="fa fa-external-link"
              @click="openNewsPage"
              v-b-tooltip
              title="If you are unable to view. Click here to open in new window"
              style="cursor:pointer"
              aria-hidden="true"
            ></i>-->
          </div>
        </div>
      </div>
      <iframe
        id="myIFrame"
        v-if="showIFrame && newsItem && newsItem.link"
        :src="newsItem.link"
        style="border: none; height: auto; min-height: 100vh"
        width="100%"
      ></iframe>
      <div
        class="row mr-0 ml-0 style-3"
        style="overflow: auto; height: auto; min-height: 100vh"
        v-else
      >
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <div style="margin-top: 40px; margin-bottom: 40px">
            <div style="margin-bottom: 6px">
              <span class="notesCardBodyName">{{ newsItem.source }},</span>
              <span class="notesCardBodyDate"
                >on {{ new Date(newsItem.time).getDate() }}
                {{ monthArray[new Date(newsItem.time).getMonth()] }}
                {{ new Date(newsItem.time).getFullYear() }}</span
              >
            </div>
            <div class="newsItemTitle">{{ newsItem.title }}</div>
            <pre class="newsItemBody">{{ newsItem.body }}</pre>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Select, Option } from "element-ui";
export default {
  name: "spv-news-feed-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      newsFeedData: [],
      newsItem: "",
      showIFrame: false,
      newsModal: false,
      monthArray: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  props: {
    newsFeedList: {
      type: Array,
      default() {
        return [];
      },
    },
    context: {
      type: String,
      default() {
        return "";
      },
    },
  },
  mounted() {},
  methods: {
    openNewsPage(item) {
      if (item.link) window.open(item.link);
    },
    readMoreMethod(item) {
      this.newsItem = item;
      this.newsModal = true;
      if (item.feed_type == "full") {
        this.showIFrame = false;
      } else {
        this.showIFrame = true;
      }
    },
    showIcons(index) {
      if (document.getElementById(`newsfeedIcons${index}`)) {
        document.getElementById(`newsfeedIcons${index}`).style.visibility =
          "visible";
      }
    },
    hideIcons(index) {
      if (document.getElementById(`newsfeedIcons${index}`)) {
        document.getElementById(`newsfeedIcons${index}`).style.visibility =
          "hidden";
      }
    },
    goToPortfolio(name) {
      let self = this;
      let portfolio = this.$store.getters["portfolio/portfolioAll"];
      let company = portfolio.find((item) => {
        if (item.name == name) {
          return item;
        }
      });
      if (company) {
        if (company.ucid) {
          let account_id = self.$route.params.account_id;
          let workspace_id = self.$route.params.workspace_id;
          self.$store.commit("temp/currentCompany", company.ucid);
          self.$router.push(
            `/${account_id}/${workspace_id}/companyProfile/${company.ucid}`
          );
        }
      }
    },
    getParsedDate(item) {
      return new Date(item.time).getDate() && new Date(item.time).getDate() < 10
        ? `0${new Date(item.time).getDate()}`
        : new Date(item.time).getDate();
    },
  },
};
</script>
<style>
.newsTitle :hover {
  text-decoration: underline;
  cursor: pointer;
}
.newsCard {
  height: 280px;
  max-height: 280px;
  /* height: 315px;
  max-height: 315px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 20px #0000000f;
  border-radius: 8px;
  opacity: 1;
}
.newsCard .card-body {
  padding: 20px 32px 14px 32px;
}

.newsFeedCardBodyLayout {
  height: 160px;
  min-height: 160px;
  max-height: 160px;
  /* height: 210px;
  min-height: 210px;
  max-height: 210px; */
  overflow: auto;
}

.newsFeedBottomLine {
  border: 0.8px solid #f0f0f0;
  opacity: 1;
}

.readMoreEllipses {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>